<template>
    <div>
        <slot></slot>
        <div v-for="(setup,j) in set" :key="'set_'+j">
            <div class="row">
                <div v-for="(master_class,i) in setup" class="col-12 col-md-4 class-well d-flex align-items-end text-center" :key="'class_'+i">
                    <div class="wrapper w-100 mb-4 mb-md-0">
                        <a :href="master_class.Content_Details_JSON__c.content_status != 'Live' ? '#' : '/'+master_class.URL_Name__c+'.html'">
                            <div class="thumbnail">
                                <img class="img-fluid" :class="master_class.Content_Details_JSON__c.content_status != 'Live' ? 'b-l' : ''" :alt="master_class.Content_Details_JSON__c.display_title" :src="master_class.Content_Details_JSON__c.thumbnail">
                            </div>
                            <p class="mt-2">{{master_class.Content_Details_JSON__c.display_title}}</p>
                        </a>
                    </div>
                </div> 
            </div>
            <hr class="w-100 d-none d-md-block">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ListClass',
        props: {
            list: Array
        },
        data: function(){
            return {
                set: []
            }
        },
        watch: {
            list(list) {
                var ix = 0;
                var set = [[]];

                for(var i = 0; i < list.length; i++) {
                    var e = list[i];
                    if(i % 3 == 0 && i != 0) {
                        set.push([]);
                        ix++;
                    }
                    set[ix].push(e);
                }

                this.set = set;
            }
        },
        mounted: function(){
        },
        methods:{
        }
    };
</script>
